import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import axios from "axios";
import { toast } from "react-toastify";

const Home = () => {

  const [productsList, setProductsList] = useState([]);
  const [inputData, setInputData] = useState({
    name: '',
    email: '',
    mobile: '',
    city: '',
    type: '',
    partner_type: '',
    message: ''
  });
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  useEffect(() => {
    setProductsList([
      {
        name: "Milk Chai",
        imageUrl: "/assets/products/Milk Chai-01-01.png"
      },
      {
        name: "Black Tea",
        imageUrl: "/assets/products/black tea-01.png"
      },
      {
        name: "Herbal Tea",
        imageUrl: "/assets/products/herbal.png"
      },
      {
        name: "Coffee",
        imageUrl: "/assets/products/cold Coffee-01-01.png"
      },
      {
        name: "Ice Tea",
        imageUrl: "/assets/products/ice tea-01-01.png"
      },
      {
        name: "Shake Mix",
        imageUrl: "/assets/products/Shakemix-01-01.png"
      },
      {
        name: "Samosa",
        imageUrl: "/assets/products/samosa-01-01.png"
      },
      {
        name: "Small Bites",
        imageUrl: "/assets/products/Small Bites-01-01.png"
      },
      {
        name: "Sandwich",
        imageUrl: "/assets/products/Sandwich-01-01.png"
      },
      {
        name: "Burger",
        imageUrl: "/assets/products/burger-01-01.png"
      },
      {
        name: "Toast",
        imageUrl: "/assets/products/Toast-01-01.png"
      },
      {
        name: "Cooler",
        imageUrl: "/assets/products/cooler-01-01.png"
      },
    ])
  }, []);

  const handleDownloadMenu = () => { 
    const pdfUrl = '/assets/Namaste Chai Menu.pdf';
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Namaste Chai Menu.pdf'; // The name given to the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCatalogue = () => {
    const pdfUrl = '/assets/Namaste Chai Retail Product Catalogue.pdf';
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Namaste-Chai-Retail-Product-Catalogue.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Name :", name, "Value :", value);
    
    setInputData((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    setSubmitBtnLoading(true);
    try {
      console.log("Input Data :", inputData);
      const formData = new FormData();
      formData.append("name", inputData.name);
      formData.append("email", inputData.email);
      formData.append("mobile", inputData.mobile);
      formData.append("city", inputData.city);
      formData.append("type", inputData.type);
      formData.append("partner_type", inputData.partner_type);
      formData.append("message", inputData.message);
      
      const response = await axios.post('https://namastechai.in/api/contact-mail.php', formData);
      console.log("Response :", response);
      setInputData({
        name: '',
        email: '',
        city: '',
        message: '',
        mobile: '',
        partner_type: '',
        type: ''
      });
      toast.success(response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    } catch (error) {
      console.log("Error :", error);
      if (error?.response) {
        let errorMessage = '';
        if ( error.response?.status === 406 ) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        }
        else if ( error.response?.status === 412 ) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setSubmitBtnLoading(false);
    }
  }

  return (
    <div className="home-page" style={{ marginTop: '-10px' }}>
      {/* Banner Section */}
      <section id="home" className="banner">
        <div id="homeCarousel" className="carousel slide main-carousel">
          <div className="carousel-inner text-center text-muted">
            <div className="carousel-item active">
              <img
                src="/assets/WebsiteBanner1.jpg"
                className="d-block w-100"
                alt="Banner 1"
                style={{ objectFit: "cover", height: "100%" }}
              />
            </div>
            <div className="carousel-item">
              <img
                src="/assets/WebsiteBanner2.jpg"
                className="d-block w-100"
                alt="Banner 1"
                style={{ objectFit: "cover", height: "100%" }}
              />
            </div>
            <div className="carousel-item">
              <img
                src="/assets/WebsiteBanner1.jpg"
                className="d-block w-100"
                alt="Banner 1"
                style={{ objectFit: "cover", height: "100%" }}
              />
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#homeCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#homeCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about"
        className="about-section py-5"
        style={{
          backgroundColor: "#FF7000",
          borderBottomLeftRadius: "18px",
          borderBottomRightRadius: "18px",
          height: "400px",
        }}
      >
        <div className="container">
          <div className="text-white p-3 p-md-5">
            <h1 className="fw-bold mb-4">WHO WE ARE</h1>
            <p className="fs-5 fs-md-3 mb-4 mb-md-5 text-center text-md-start">
              Namaste Chai was born from a passion for preserving the rich
              heritage of Indian chai while meeting the evolving demands of
              modern lifestyles. Our mission is to make premium, authentic chai
              accessible to everyone, whether at home, in the office, or on the
              go.
            </p>
            <div className="row justify-content-center g-5">
              {/* <div className="col-md-5 col-10">
                <div
                  className="bg-white about-card d-flex align-items-center justify-content-between"
                  style={{
                    height: "30vh",
                    minHeight: "200px",
                    borderTopLeftRadius: "20px",
                    borderTopRightRadius: "20px",
                  }}
                >
                  <img
                    src="/assets/namaste/a1.png"
                    alt="About 1"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                  <p style={{ color: "#FF7000" }}>
                    <b>MISSION : </b>
                    To Make Chai Accessible & Enjoyable Anytime, Anywhere
                  </p>
                </div>
              </div>
              <div className="col-md-5 col-10">
                <div
                  className="bg-white about-card d-flex align-items-center justify-content-between"
                  style={{
                    height: "30vh",
                    minHeight: "200px",
                    borderTopRightRadius: "20px",
                    borderTopLeftRadius: "20px",
                  }}
                >
                  <img
                    src="/assets/namaste/a2.png"
                    alt="About 2"
                    style={{
                      height: "100%",
                      wdth: "100%",
                      objectFit: "contain",
                    }}
                  />
                  <p style={{ color: "#FF7000" }}>
                    <b>VISION : </b>
                    To be a globally renowned tea brand, known for quality and
                    innovation.
                  </p>
                </div>
              </div> */}
              <div className="d-flex justify-content-between misson-vision">
                <div className="mission">
                  <img className="mission-img" src="/assets/nnn/img1.png" alt="" />
                </div>
                <div className="vision">
                  <img className="vision-img" src="/assets/nnn/img2.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ marginTop: "180px" }}>
        <div
          className="container"
          style={{ maxWidth: "1000px", color: "#FF7000" }}
        >
          <h1 className="fw-bold our-promise-text">OUR PROMISE</h1>
          <h4>
            We Deliver Not Just A Product But An Experience – A Perfect Blend Of
            Tradition, Taste, And Convenience That Resonates With Chai Lovers
            Everywhere. With Every Sip, We Aim To Bring Comfort, Connection, And
            Joy.
          </h4>
        </div>
      </section>

      <section className="mt-5">
        <div className="container px-5 py-2" style={{ maxWidth: "1000px" }}>
          <div className="row">
            <div
              className="col-8 d-flex"
              style={{
                backgroundColor: "#FFE7D5",
                borderBottomLeftRadius: "98px",
                // height: "510px",
                width: "90%",
              }}
            >
              <div className="row">
                <div className="col-8">
                  <div className="row">
                    <div className="col-9">
                      <h1
                        style={{
                          color: "#FF7000",
                          fontSize: "50px",
                          paddingTop: "24px",
                          paddingLeft: "20px",
                          fontWeight: "900",
                        }}
                      >
                        WHY CHOOSE NAMASTE CHAI
                      </h1>
                    </div>
                    <div className="col-3">
                      <img
                        className="hide-on-small"
                        src="/assets/namaste/questionMark.png"
                        alt="About 2"
                        style={{ width: "100%", objectFit: "cover", height: '100%' }}
                      />
                    </div>
                  </div>
                  <ul className="custom-list">
                    <li>
                      <h6
                        className="fw-bold mb-0 pt-2"
                        style={{ color: "#FF7000" }}
                      >
                        AUTHENTICITY & INNOVATION:
                      </h6>
                      <span
                        className="fw-semibold"
                        style={{ color: "#723300", fontSize: "14px" }}
                      >
                        Traditional chai taste, perfectly blended with modern
                        convenience.
                      </span>
                    </li>
                    <li>
                      <h6
                        className="fw-bold mb-0 pt-0"
                        style={{ color: "#FF7000" }}
                      >
                        PREMIUM QUALITY:
                      </h6>
                      <span
                        className="fw-semibold"
                        style={{ color: "#723300", fontSize: "14px" }}
                      >
                        Only high-grade ingredients and natural flavors for a
                        premium experience
                      </span>
                    </li>
                    <li>
                      <h6
                        className="fw-bold mb-0 pt-0"
                        style={{ color: "#FF7000" }}
                      >
                        CONVENIENCE:
                      </h6>
                      <span
                        className="fw-semibold"
                        style={{ color: "#723300", fontSize: "14px" }}
                      >
                        Instant solutions designed for today’s fast-paced,
                        on-the-go lifestyles
                      </span>
                    </li>
                    <li>
                      <h6
                        className="fw-bold mb-0 pt-0"
                        style={{ color: "#FF7000" }}
                      >
                        CONSISTENCY:
                      </h6>
                      <span
                        className="fw-semibold"
                        style={{ color: "#723300", fontSize: "14px" }}
                      >
                        Known for delivering reliable, high-quality products
                        every time
                      </span>
                    </li>
                    <li>
                      <h6
                        className="fw-bold mb-0 pt-0"
                        style={{ color: "#FF7000" }}
                      >
                        VERSATILITY:
                      </h6>
                      <span
                        className="fw-semibold"
                        style={{ color: "#723300", fontSize: "14px" }}
                      >
                        {" "}
                        Ideal for homes, offices, and wherever you need a quick,
                        refreshing chai.
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="col-4">
                  <img
                     className="hide-on-small"
                    src="/assets/nnn/tea.png"
                    alt="About 2"
                    style={{ width: "190%", objectFit: "cover", height: '120%' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="container">
          <h2 className="text-center fw-bold " style={{ color: '#723300' }}>FEATURED IN</h2>
          <div class="row text-center d-flex align-items-center pt-3 pt-md-5 pb-3 pb-md-5">
            <div class="col">
              <img class="img-fluid" src="assets/nnn/goatimes.png" alt="" />
            </div>
            <div class="col">
              <img class="img-fluid" src="assets/nnn/incrediblegoa.svg" alt="" />
            </div>
            <div class="col">
              <img class="img-fluid" src="assets/nnn/bombaytimes.png" alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* Franchise Section */}
      <section id="franchise">
        <div className="container px-5 py-2" style={{ maxWidth: "1000px" }}>
          <div className="row">
            <div
              className="col-8 d-flex"
              style={{
                backgroundColor: "#FFE7D5",
                borderBottomRightRadius: "98px",
                height: "450px",
                width: "90%",
                marginLeft: '180px'
              }}
            >
              <div className="row">
                <div className="col-3">
                  <div className="mt-5 franchise-outlet" style={{ marginLeft: '-200px' }}>
                    <img src="assets/nnn/outlet.png" className="franchise-oultet-img" alt="" style={{ height: '350px' }} />
                  </div>
                </div>
                <div className="col-9" style={{ paddingLeft: '40px' }}>
                  <h1 className="text-center mt-5" style={{ color: '#FF7900', fontWeight: '800', fontSize: '45px' }}>FRANCHISE WITH US</h1>

                  <div className="d-flex justify-content-around mt-5">
                    <div className="text-center">
                      <img src="assets/nnn/65.png" alt="" style={{ height: '120px' }} />
                      <h2 className="fw-bold mt-2" style={{ color: '#FF7900' }}>*Upto 65% Profit Margin</h2>
                    </div>
                    <div className="text-center">
                      <img src="assets/nnn/rupee.png" alt="" style={{ height: '120px ' }} />
                      <h2 className="fw-bold mt-2" style={{ color: '#FF7900' }}>Low Investment (8L-10L)</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5" style={{ backgroundColor: '#FFE7D5', borderTopLeftRadius: '80px', borderBottomRightRadius: '80px' }}>
        <div className="container p-4" >
          <div className="row" style={{ color: '#FF7900', paddingLeft: '140px', paddingRight: '140px' }}>
            <div className="col text-center">
              <img src="assets/nnn/premium.png" alt="assets/nnn/premium.png" style={{ height: '90px' }} />
              <h5 className="fw-bold">Premium Quality at Affordable Price</h5>
            </div>
            <div className="col text-center">
              <img src="assets/nnn/quick.png" alt="assets/nnn/quick.png" style={{ height: '90px' }} />
              <h5 className="fw-bold">Quick Service</h5>
            </div>
            <div className="col text-center">
              <img src="assets/nnn/zero.png" alt="assets/nnn/zero.png" style={{ height: '90px' }} />
              <h5 className="fw-bold">Zero Wastage</h5>
            </div>
            <div className="col text-center">
              <img src="assets/nnn/professional.png" alt="assets/nnn/professional.png" style={{ height: '90px' }} />
              <h5 className="fw-bold">Professional Team Back Up</h5>
            </div>
            <div className="col text-center">
              <img src="assets/nnn/easy.png" alt="assets/nnn/easy.png" style={{ height: '90px' }} />
              <h5 className="fw-bold">Easy Management & Operation</h5>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Content Section */}
      <section className="py-5 my-md-5">
        <div className="container">
          <h1 className="text-center mb-5 fw-bold" style={{ color: '#723300' }}>OUR OUTLET PRODUCT</h1>
          <div className="row g-4" style={{ marginRight: '100px', marginLeft: '100px' }}>
            {productsList?.map((item) => (
              <div key={item} className="col-md-2 col-4 mb-5 mt-5">
                <div
                  className="p-3 text-center"
                  style={{ height: "130px", backgroundColor: '#FFE7D5', borderColor: '#FFE7D5', borderRadius: '24px' }}
                >
                  <img src={item.imageUrl} alt="NO-IMG" style={{ height: '145px', width: '125px', marginTop: '-75px' }} />
                  <h5 className="fw-bold mt-2" style={{ color: '#723300' }}>{item.name}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center">
          <button className="btn p-3 fw-semibold" style={{ backgroundColor: '#FF7900', color: 'white', fontSize: '20px', borderRadius: '24px' }} onClick={handleDownloadMenu} >Download Menu</button>
        </div>
      </section>

      <section style={{ marginTop: '-50px' }}>
        <div className="container text-center">
          <h2 className="fw-bold" style={{ color: '#723300' }}>UNIT FRANCHISE REQUIRMENTS</h2>
          <div className="container" style={{ marginTop: '120px', paddingLeft: '250px', paddingRight: '250px' }}>
            <div className="row justify-content-around gap-5" style={{ color: 'white' }}>
              <div className="col text-center" style={{ backgroundColor: '#FF7900', height: '290px', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                <img src="assets/nnn/outlet1.png" alt="" style={{ height: '160px', marginTop: '-80px' }} />
                <h5 className="mt-2">OUTLET</h5>
                <p>Minimum 100-200 sqft outlet at a
                  busy location which can be near
                  to bus stops, highways, hospitals,
                  markets, railway stations, IT
                  campus, colleges etc.</p>
              </div>
              <div className="col" style={{ backgroundColor: '#FF7900', height: '290px', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                <img src="assets/nnn/interior.png" alt="" style={{ height: '160px', marginTop: '-80px' }} />
                <h5 className="mt-2">INTERIOR</h5>
                <p>The outlet should have tile ooring
                  kitchen partition, water connection.
                  Franchisee has to arrange the said
                  ones only. The rest of all the brand
                  will take care of.</p>
              </div>
              <div className="col" style={{ backgroundColor: '#FF7900', height: '290px', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                <img src="assets/nnn/kitchen.png" alt="" style={{ height: '160px', marginTop: '-80px' }} />
                <h5 className="mt-2">KITCHEN</h5>
                <p>Get 2 employees who will be
                  trained by our chef to run your
                  business. Anybody can learn the
                  entire Namaste chai menu in 3
                  days</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: '#FFE7D5' }}>
        <div className="container text-center">
          <h2 className="fw-bold" style={{ color: '#723300', paddingTop: '60px' }}>YOUR NAMASTE CHAI OUTLET IN JUST 5 STEPS!</h2>
          <img src="assets/stepp.jpeg" alt="" style={{ width: '100%', display: 'block', margin: 0, padding: 0 }} />
        </div>
      </section>

      <section id="outlet" style={{
        backgroundImage: "url('assets/nnn/bg-img.png')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
      }}>
        {/* <div style={{ backgroundColor: '#FF7000', margin: '0 10% 0 10%' }} className="row justify-content-center">
          <div className="col-3 text-center">
            <h1 className="" style={{ color: 'white', fontWeight: '800' }}>10,00,000 +</h1>
            <h5 style={{ color: '#fff' }}>Daily Customers</h5>
          </div>
          <div className="col-3 text-center">
            <h1 className="" style={{ color: 'white', fontWeight: '800' }}>100 +</h1>
            <h5 style={{ color: '#fff' }}>Outlets</h5>
          </div>
          <div className="col-3 text-center">
            <h1 className="" style={{ color: 'white', fontWeight: '800' }}>100 +</h1>
            <h5 style={{ color: '#fff' }}>Successful Entrepreneurers</h5>
          </div>
        </div> */}

        <div className="pe-1 ps-1 rounded-bottom-5" style={{ background: '#fff', margin: '0 10% 0 10%', marginBottom: '10%', background: 'rgba(255, 255, 255, 0.8)' }}>

          <div className="row justify-content-center">
            <h2 className="text-center fw-bold" style={{ color: '#723300', padding: '5% 0 2% 0' }}>LOCATIONS</h2>
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center fw-bold" style={{ color: '#723300' }}>MUMBAI</h1>
            </div>
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center fw-bold" style={{ color: '#723300' }}>GOA</h1>
            </div>
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center fw-bold" style={{ color: '#723300' }}>PUNE</h1>
            </div>
           
          </div>

          <div className="row justify-content-center mt-4">
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center fw-bold" style={{ color: '#723300' }}>KARWAR</h1>
            </div><div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center fw-bold" style={{ color: '#723300' }}>JALANDAR</h1>
            </div><div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center fw-bold" style={{ color: '#723300' }}>BELGAUM</h1>
            </div>
          </div>

          {/* CUSTOMER TESTIMONIALS  */}
          <div className="row justify-content-center mt-5 pb-5">
            {/* <h2 className="text-center fw-bold" style={{ color: '#723300' }}>CUSTOMER TESTIMONIALS</h2>
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center" style={{ color: '#723300' }}>MUMBAI</h1>
            </div>
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center" style={{ color: '#723300' }}>GOA</h1>
            </div>
            <div className="col-3">
              <img style={{ width: '100%' }} src="assets/nnn/franchise-img.png" />
              <h1 className="text-center" style={{ color: '#723300' }}>PUNE</h1>
            </div> */}
          </div>
        </div>

        {/* Apply Now Button */}
        <div id="Apply-now" class="franchise-form pt-5 pb-4 pb-md-5" style={{ position: 'relative' }}>
          <div class="d-flex justify-content-center container border-radius">
            <div class="row" style={{ width: '900px', backgroundColor: '#FF7000', borderRadius: '25px', marginBottom: '-35%' }}>
              <div class="col-5 p-4 pt-5 text-white" >
                <p class="fw-800 ms-3 mb-0" style={{ textDecoration: 'none', fontSize: '22px' }}>Welcome To</p>
                <h1 class="fw-800 ms-3" style={{ textDecoration: 'none', fontSize: '58px' }}>NAMASTE <br /> CHAI</h1>
                <h5 class="fw-800 ms-3" style={{ textDecoration: 'none', fontSize: '30px' }}>At Namaste Chai, We<br />
                  Believe Chai <br />
                  Is More Than Just A<br />
                  Beverage –<br />
                  It’s An Emotion, A<br />
                  Ritual, And<br />
                  A Bond That Brings<br />
                  People Together.</h5>
              </div>
              <div class="col-7 p-3 pt-5 pb-5" >
                <div class="border-radius3 pt-1 pb-1" style={{ backgroundColor: "#FFDABE" }}>
                  <form class="p-3 pt-1 pb-1" action="">
                    <div class="mb-3">
                      <label for="inputName" class="form-label fw-500">Full Name</label>
                      <input class="form-control" onChange={handleChange} name="name" value={inputData.name} />
                    </div>
                    <div class="mb-3">
                      <label for="inputCity" class="form-label fw-500">Email ID</label>
                      <input class="form-control" onChange={handleChange} name="email" value={inputData.email} />
                    </div>

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <label class="form-label fw-500">Mobile Number</label>
                        <input class="form-control" onChange={handleChange} name="mobile" value={inputData.mobile} />
                      </div>
                      <div class="col-md-6 pt-3 pt-md-0">
                        <label class="form-label fw-500">City</label>
                        <input class="form-control" onChange={handleChange} name="city" value={inputData.city} />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label fw-500">Enquiry Type</label>
                        <select class="form-select" onChange={handleChange} name="type" value={inputData.type}>
                          <option value="">Select Enquiry type</option>
                          <option value="CUSTOMER">I am Customer</option>
                          <option value="PARTNER">Want to be partner</option>
                        </select>
                      </div>
                      <div class="col-md-6 pt-3 pt-md-0 mb-3">
                        <label class="form-label fw-500">Partnership type</label>
                        <select class="form-select" onChange={handleChange} name="partner_type" value={inputData.partner_type}>
                          <option value="">Select type</option>
                          <option value="DISTRIBUTOR">Want to be Distributor</option>
                          <option value="FRANCHISE">Want to take Franchise</option>
                          <option value="RETAILER">Retailer</option>
                        </select>
                      </div>
                      <div class="col-md-12 pt-3 pt-md-0">
                        <label class="form-label fw-500">Your Message</label>
                        <textarea class="form-control" rows="3" onChange={handleChange} value={inputData.message} name="message" ></textarea>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center pt-3 pb-2 m-3 mb-0 mt-0" >
                      <button class="btn btn-primary btn-rounded p-2 w-100 fw-700" onClick={handleSubmitForm} disabled={ !inputData.name || !inputData.city || !inputData.email || !inputData.message || !inputData.partner_type || !inputData.type || !inputData.mobile || submitBtnLoading  }>
                        {submitBtnLoading ? (
                          <>
                            <span 
                              className="spinner-border spinner-border-sm me-2" 
                              role="status" 
                              aria-hidden="true"
                              style={{ width: '0.9rem', height: '1rem' }}
                            ></span>
                            Sending...
                          </>
                        ) : (
                          'Send Request'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Distributorship Section */}
      <section id="distributorship" className="text-center" style={{ paddingTop: '22%', backgroundColor: '#FFE7D5' }}>
        <h1 style={{ color: '#FF7000', fontWeight: '900', fontSize: '50px', paddingBottom: '28px' }}>BECOME A NAMASTE <br />
          CHAI DISTRIBUTOR</h1>
        <img style={{ width: '65%', textAlign: 'center', marginBottom: '-15%' }} src="assets/nnn/products.png" />
      </section>

      <section style={{ paddingTop: '18%', display: 'flex', justifyContent: 'center' }}>
        <div className="row  justify-content-center">
          <div style={{ borderLeft: '6px solid #FF7000' }} className="col-6 text-start">
            <h3 style={{ fontSize: '35px', paddingTop: '12px', fontWeight: '800', color: '#FF7000' }}>DIVERSE OFFERINGS: </h3>
            <h5 style={{ fontWeight: '800', fontSize: '24px', color: '#723300' }}>A wide range of products designed <br />
              to cater to the evolving preferences <br />
              of today's consumers</h5>
          </div>
          <div style={{ borderLeft: '4px solid #FF7000' }} className="col-6 text-start">
            <h3 style={{ fontSize: '35px', paddingTop: '12px', fontWeight: '800', color: '#FF7000' }}>CONVENIENCE & QUALITY: </h3>
            <h5 style={{ fontWeight: '800', fontSize: '24px', color: '#723300' }}>Products crafted to provide<br />
              convenience without compromising<br />
              on taste or quality.</h5>
          </div>
        </div>
      </section>

      <section style={{ marginTop: '8%', backgroundColor: '#FF7000', display: 'flex', flexDirection: 'column', justifyContent: 'center', borderRadius: '120px', borderTopLeftRadius: '0px', borderTopRightRadius: '0px' }}>
        <h2 className="text-center text-white p-5">Join hands with namaste chai, a rapidly growing brand in the<br />
          tea industry. As our distributor, you get access to high-demand<br />
          products, competitive margins, and strong brand support. We<br />
          ensure seamless supply, marketing assistance, and exclusive<br />
          business benefits to help you succeed. Partner with us and bring<br />
          the authentic taste of namaste chai to your region</h2>

          <div className="row p-5 justify-content-center">
            <div className="col-3 text-center text-white">
              <img style={{ width: '40%'}} src="assets/nnn/bulk.png" />
              <h3 style={{ fontWeight: '800' }}>BULK<br />SUPPLY</h3>
            </div>
            <div className="col-3 text-center text-white">
              <img style={{ width: '40%'}} src="assets/nnn/margin.png" />
              <h3 style={{ fontWeight: '800' }}>HIGH<br />MARGINS</h3>
            </div>
            <div className="col-3 text-center text-white">
              <img style={{ width: '40%'}} src="assets/nnn/marketing.png" />
              <h3 style={{ fontWeight: '800' }}>MARKETING<br />SUPPORT</h3>
            </div>
            <div className="col-3 text-center text-white">
              <img style={{ width: '40%'}} src="assets/nnn/brand.png" />
              <h3 style={{ fontWeight: '800' }}>FAST-GROWING<br />BRAND</h3>
            </div>

            <div style={{ borderRadius: '14px', cursor: 'pointer' }} className="m-5 p-3 mb-0 col-2 text-center bg-white"
              onClick={() => {
                const formSection = document.getElementById('Apply-now');
                if (formSection) {
                  formSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <h4 style={{ color: '#FF7000', fontWeight: '800' }} >Apply Now</h4>
            </div>

          </div>
          
      </section>

      {/* Product Category */}
      <section className="" style={{ paddingTop: '3%' }}>
        <h1 className="text-center" style={{ color: '#723300' }}>PRODUCT CATEGORIES</h1>
        <div className="container" style={{ color: '#723300', paddingLeft: '120px', paddingRight: '120px' }}>
          <div className="row" style={{ gap: '80px', marginTop: '100px' }}>
            <div className="col text-center" style={{ height: '150px', backgroundColor: '#FFE7D5', borderBottomRightRadius: '24px', borderBottomLeftRadius: '24px' }}>
              <img src="assets/nnn/premix.png" alt="" style={{ height: '160px', marginTop: '-80px' }} />
              <h1 className="fw-bold">3 IN 1 PREMIX</h1>
            </div>
            <div className="col text-center" style={{ height: '150px', backgroundColor: '#FFE7D5', borderBottomRightRadius: '24px', borderBottomLeftRadius: '24px' }}>
              <img src="assets/nnn/herbal.png" alt="" style={{ height: '160px', marginTop: '-80px' }} />
              <h1 className="fw-bold">HERBAL TEA</h1>
            </div>
          </div>

          <div className="row" style={{ gap: '80px', marginTop: '120px' }}>
            <div className="col text-center" style={{ height: '150px', backgroundColor: '#FFE7D5', borderBottomRightRadius: '24px', borderBottomLeftRadius: '24px' }}>
              <img src="assets/nnn/sweet.png" alt="" style={{ height: '190px', marginTop: '-100px' }} />
              <h1 className="fw-bold">SWEET & SNACKS</h1>
            </div>
            <div className="col text-center" style={{ height: '150px', backgroundColor: '#FFE7D5', borderBottomRightRadius: '24px', borderBottomLeftRadius: '24px' }}>
              <img src="assets/nnn/beverage.png" alt="" style={{ height: '190px', marginTop: '-100px' }} />
              <h1 className="fw-bold">BEVERAGE</h1>
            </div>
          </div>

          <div className="row p-5 justify-content-center">
            <div style={{ backgroundColor: '#FF7000', borderRadius: '14px', cursor: 'pointer' }} onClick={handleDownloadCatalogue} className="m-1 p-3 mb-0 col-3 text-center">
              <h5 style={{ color: '#fff', fontWeight: '800' }}>Download Catalogue</h5>
            </div>
          </div>

        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">What Our Customers Say</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <p className="card-text">
                    "The best chai I've ever had outside of India!"
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <p className="card-text">
                    "Authentic taste that reminds me of home."
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <p className="card-text">
                    "Perfect balance of spices and sweetness."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;